export const messages = {
  en: {
    couponDetailManage: {
      search: {
        title: 'Search Conditions',
        poolId: 'Please enter coupon',
        shopId: 'Please enter shop ID'
      },
      list: {
        title: 'Merchant Purchase Records'
      },
      table: {
        detailId: 'Detail ID',
        shopName: 'Shop',
        couponName: 'Coupon Name',
        actualPrice: 'Face Value',
        buyPrice: 'Purchase Price',
        amount: 'Payment Amount',
        buyCount: 'Purchase Quantity',
        validityDay: 'Validity Period'
      },
      add: {
        title: 'Add Merchant Purchase Record',
        poolId: 'Coupon',
        poolIdPlaceholder: 'Required, please enter coupon',
        shopId: 'Shop',
        shopIdPlaceholder: 'Required, please enter shop ID',
        couponName: 'Coupon Name',
        couponNamePlaceholder: 'Required, please enter coupon name',
        actualPrice: 'Face Value',
        actualPricePlaceholder: 'Required, please enter face value',
        buyPrice: 'Purchase Price',
        buyPricePlaceholder: 'Required, please enter purchase price',
        amount: 'Payment Amount',
        amountPlaceholder: 'Required, please enter payment amount',
        buyCount: 'Purchase Quantity',
        buyCountPlaceholder: 'Required, please enter purchase quantity',
        validityDay: 'Validity Period',
        validityDayPlaceholder: 'Required, please enter validity period',
        success: 'Added successfully'
      },
      edit: {
        title: 'Edit Merchant Purchase Record',
        poolId: 'Coupon',
        poolIdPlaceholder: 'Required, please enter coupon',
        shopId: 'Shop',
        shopIdPlaceholder: 'Required, please enter shop ID',
        couponName: 'Coupon Name',
        couponNamePlaceholder: 'Required, please enter coupon name',
        actualPrice: 'Face Value',
        actualPricePlaceholder: 'Required, please enter face value',
        buyPrice: 'Purchase Price',
        buyPricePlaceholder: 'Required, please enter purchase price',
        amount: 'Payment Amount',
        amountPlaceholder: 'Required, please enter payment amount',
        buyCount: 'Purchase Quantity',
        buyCountPlaceholder: 'Required, please enter purchase quantity',
        validityDay: 'Validity Period',
        validityDayPlaceholder: 'Required, please enter validity period',
        success: 'Updated successfully'
      },
      delete: {
        title: 'Confirm Operation',
        confirm: 'Are you sure to delete this merchant purchase record?',
        success: 'Deleted successfully'
      },
      validate: {
        detailIdRequired: 'Detail ID is required',
        poolIdRequired: 'Coupon is required',
        poolIdMaxLength: 'Coupon cannot exceed 30 characters',
        shopIdRequired: 'Shop ID is required',
        shopIdMaxLength: 'Shop ID cannot exceed 30 characters',
        couponNameRequired: 'Coupon name is required',
        couponNameMaxLength: 'Coupon name cannot exceed 64 characters',
        actualPriceRequired: 'Face value is required',
        actualPriceNumber: 'Face value must be a number',
        buyPriceRequired: 'Purchase price is required',
        buyPriceNumber: 'Purchase price must be a number',
        amountRequired: 'Payment amount is required',
        amountNumber: 'Payment amount must be a number',
        buyCountRequired: 'Purchase quantity is required',
        buyCountNumber: 'Purchase quantity must be a number',
        validityDayRequired: 'Validity period is required',
        validityDayNumber: 'Validity period must be a number'
      },
      fetchError: 'Failed to fetch coupon details'
    }
  },
  zh: {
    couponDetailManage: {
      search: {
        title: '查询条件',
        poolId: '请输入优惠券',
        shopId: '请输入店铺ID'
      },
      list: {
        title: '商家购买记录'
      },
      table: {
        detailId: '商家购买记录表ID',
        shopName: '店铺',
        couponName: '优惠券名称',
        actualPrice: '面值',
        buyPrice: '购买价格',
        amount: '付款金额',
        buyCount: '购买数量',
        validityDay: '有效期'
      },
      add: {
        title: '添加商家购买记录表',
        poolId: '优惠券',
        poolIdPlaceholder: '必填，请填写优惠券',
        shopId: '店铺',
        shopIdPlaceholder: '必填，请填写店铺ID',
        couponName: '优惠券名称',
        couponNamePlaceholder: '必填，请填写优惠券名称',
        actualPrice: '面值',
        actualPricePlaceholder: '必填，请填写面值',
        buyPrice: '购买价格',
        buyPricePlaceholder: '必填，请填写购买价格',
        amount: '付款金额',
        amountPlaceholder: '必填，请填写付款金额',
        buyCount: '购买数量',
        buyCountPlaceholder: '必填，请填写购买数量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，请填写有效期',
        success: '添加成功'
      },
      edit: {
        title: '修改商家购买记录表',
        poolId: '优惠券',
        poolIdPlaceholder: '必填，请填写优惠券',
        shopId: '店铺',
        shopIdPlaceholder: '必填，请填写店铺ID',
        couponName: '优惠券名称',
        couponNamePlaceholder: '必填，请填写优惠券名称',
        actualPrice: '面值',
        actualPricePlaceholder: '必填，请填写面值',
        buyPrice: '购买价格',
        buyPricePlaceholder: '必填，请填写购买价格',
        amount: '付款金额',
        amountPlaceholder: '必填，请填写付款金额',
        buyCount: '购买数量',
        buyCountPlaceholder: '必填，请填写购买数量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，请填写有效期',
        success: '修改成功'
      },
      delete: {
        title: '请确认您的操作',
        confirm: '确定删除商家购买记录',
        success: '删除成功'
      },
      validate: {
        detailIdRequired: '记录ID不能为空',
        poolIdRequired: '优惠券不能为空',
        poolIdMaxLength: '优惠券不能超过30',
        shopIdRequired: '店铺ID不能为空',
        shopIdMaxLength: '店铺ID不能超过30',
        couponNameRequired: '优惠券名称不能为空',
        couponNameMaxLength: '优惠券名称不能超过64',
        actualPriceRequired: '面值不能为空',
        actualPriceNumber: '面值必须是数字',
        buyPriceRequired: '购买价格不能为空',
        buyPriceNumber: '购买价格必须是数字',
        amountRequired: '付款金额不能为空',
        amountNumber: '付款金额必须是数字',
        buyCountRequired: '购买数量不能为空',
        buyCountNumber: '购买数量必须是数字',
        validityDayRequired: '有效期不能为空',
        validityDayNumber: '有效期必须是数字'
      },
fetchError: '获取优惠券详情失败'
    }
  },
  'zh-TW': {
    couponDetailManage: {
      search: {
        title: '查詢條件',
        poolId: '請輸入優惠券',
        shopId: '請輸入店鋪ID'
      },
      list: {
        title: '商家購買記錄'
      },
      table: {
        detailId: '商家購買記錄表ID',
        shopName: '店鋪',
        couponName: '優惠券名稱',
        actualPrice: '面值',
        buyPrice: '購買價格',
        amount: '付款金額',
        buyCount: '購買數量',
        validityDay: '有效期'
      },
      add: {
        title: '添加商家購買記錄表',
        poolId: '優惠券',
        poolIdPlaceholder: '必填，請填寫優惠券',
        shopId: '店鋪',
        shopIdPlaceholder: '必填，請填寫店鋪ID',
        couponName: '優惠券名稱',
        couponNamePlaceholder: '必填，請填寫優惠券名稱',
        actualPrice: '面值',
        actualPricePlaceholder: '必填，請填寫面值',
        buyPrice: '購買價格',
        buyPricePlaceholder: '必填，請填寫購買價格',
        amount: '付款金額',
        amountPlaceholder: '必填，請填寫付款金額',
        buyCount: '購買數量',
        buyCountPlaceholder: '必填，請填寫購買數量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，請填寫有效期',
        success: '添加成功'
      },
      edit: {
        title: '修改商家購買記錄表',
        poolId: '優惠券',
        poolIdPlaceholder: '必填，請填寫優惠券',
        shopId: '店鋪',
        shopIdPlaceholder: '必填，請填寫店鋪ID',
        couponName: '優惠券名稱',
        couponNamePlaceholder: '必填，請填寫優惠券名稱',
        actualPrice: '面值',
        actualPricePlaceholder: '必填，請填寫面值',
        buyPrice: '購買價格',
        buyPricePlaceholder: '必填，請填寫購買價格',
        amount: '付款金額',
        amountPlaceholder: '必填，請填寫付款金額',
        buyCount: '購買數量',
        buyCountPlaceholder: '必填，請填寫購買數量',
        validityDay: '有效期',
        validityDayPlaceholder: '必填，請填寫有效期',
        success: '修改成功'
      },
      delete: {
        title: '請確認您的操作',
        confirm: '確定刪除商家購買記錄',
        success: '刪除成功'
      },
      validate: {
        detailIdRequired: '記錄ID不能為空',
        poolIdRequired: '優惠券不能為空',
        poolIdMaxLength: '優惠券不能超過30',
        shopIdRequired: '店鋪ID不能為空',
        shopIdMaxLength: '店鋪ID不能超過30',
        couponNameRequired: '優惠券名稱不能為空',
        couponNameMaxLength: '優惠券名稱不能超過64',
        actualPriceRequired: '面值不能為空',
        actualPriceNumber: '面值必須是數字',
        buyPriceRequired: '購買價格不能為空',
        buyPriceNumber: '購買價格必須是數字',
        amountRequired: '付款金額不能為空',
        amountNumber: '付款金額必須是數字',
        buyCountRequired: '購買數量不能為空',
        buyCountNumber: '購買數量必須是數字',
        validityDayRequired: '有效期不能為空',
        validityDayNumber: '有效期必須是數字'
      },
      fetchError: '獲取優惠券詳情失敗'
    }
  }
}